const SMS_DASHBOARD_MENU = {
  title: "Dashboard",
  route: "serverManagementDashboard",
  icon: "HomeIcon",
}
const SMS_ALL_EVENT_MENU = {
  title: "All Events",
  route: "serverManagementAllEvents",
  icon: "BookmarkIcon",
}
const SMS_SERVER_MANAGEMENT_MENU = {
  title: "Server Management",
  route: "serverManagementServerManagement",
  icon: "ServerIcon",
}
const SMS_ALERT_MENU = {
  title: "Alert",
  route: "serverManagementAlert",
  icon: "BellIcon",
}
const SMS_REPORT_MENU = {
  title: "Report",
  route: "serverManagementReport",
  icon: "FileTextIcon",
}
const SMS_DISCOVERY_MENU = {
  title: "Discovery",
  route: "serverManagementDiscovery",
  icon: "ZoomInIcon",
}
const SMS_POLICY_MENU = {
  title: "Policy",
  route: "serverManagementPolicy",
  icon: "FlagIcon",
}

export {
  SMS_DASHBOARD_MENU,
  SMS_ALL_EVENT_MENU,
  SMS_SERVER_MANAGEMENT_MENU,
  SMS_ALERT_MENU,
  SMS_REPORT_MENU,
  SMS_DISCOVERY_MENU,
  SMS_POLICY_MENU,
}
